import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from 'react-select';
import { Field, reduxForm, reset, formValueSelector } from "redux-form";
import queryString from "query-string";

import "./RequestList.css"

import history from "../../../../history";
import { getReasons } from "../../../../actions/absenceActions";
import { getSubordinateUsers } from "../../../../actions/userActions"
import { getSubordinateUnits } from "../../../../actions/structureActions"
import { getMyRequests, getPendingRequests, getOtherRequests, getAllRequests } from "../../../../actions/requestActions";

import Form from "../../../CustomViews/Form";

const FiltersForm = reduxForm({ form: "filtersForm" })(Form);

class RequestList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ouID: { label: "< Wszystkie >", value: null },
            userID: { label: "< Wszyscy >", value: null },
            requestID: 1,
            filters: false
        };
    }

    componentDidMount() {
        let queryParams = queryString.parse(history.location.search);
        if (!(Object.keys(queryParams).length === 0 || (Object.keys(queryParams).length === 1 && queryParams.page !== null && queryParams.page !== undefined))) history.push({ search: `page=${queryParams.page}` });

        this.startListScope = "";
        this.startListType = "";
        this.startPage = 1;
        this.lastFiltersParams = {};
        this.filtersParams = {};
        this.updateList();
        this.props.getReasons();
        this.props.getSubordinateUsers();
        this.props.getSubordinateUnits();
    }

    componentDidUpdate() {
        this.updateFilters();
        this.updateList();
    }

    updateList = () => {
        this.queryParams = queryString.parse(history.location.search);
        let curFilters = this.getFilters(this.queryParams);
        this.page = this.queryParams.page > 0 ? (this.queryParams.page <= this.props.pages ? +this.queryParams.page : this.props.pages) : 1
        if (this.props.listScope !== this.startListScope || this.props.listType !== this.startListType || this.page !== this.startPage || JSON.stringify(this.lastFiltersParams) !== JSON.stringify(curFilters)) {
            if (this.props.listType !== this.startListType) {
                this.props.reset("filtersForm");
                this.setState({
                    ouID: { label: "< Wszystkie >", value: null },
                    userID: { label: "< Wszyscy >", value: null }
                });
            }
            this.startListScope = this.props.listScope;
            this.startListType = this.props.listType;
            this.startPage = this.page;
            this.lastFiltersParams = { ...curFilters };
            if (this.props.listType === "my") this.props.getMyRequests(this.page, curFilters);
            else if (this.props.listType === "pending") this.props.getPendingRequests(this.props.listScope, this.page, curFilters);
            else if (this.props.listType === "other") this.props.getOtherRequests(this.props.listScope, this.page, curFilters);
            else if (this.props.listType === "all") this.props.getAllRequests(this.props.listScope, this.page, curFilters);
        }
    };

    getFilters = queryParams => {
        let filters = { ...this.filtersParams };
        if (queryParams.absenceID !== filters.absenceID)
            if (queryParams.absenceID !== null && queryParams.absenceID !== undefined) filters.absenceID = queryParams.absenceID; else delete filters.absenceID;
        if (queryParams.startDate !== filters.startDate)
            if (queryParams.startDate !== null && queryParams.startDate !== undefined) filters.startDate = queryParams.startDate; else delete filters.startDate;
        if (queryParams.endDate !== filters.endDate)
            if (queryParams.endDate !== null && queryParams.endDate !== undefined) filters.endDate = queryParams.endDate; else delete filters.endDate;
        if (queryParams.ouID !== filters.ouID)
            if (queryParams.ouID !== null && queryParams.ouID !== undefined) filters.ouID = queryParams.ouID; else delete filters.ouID;
        if (queryParams.userID !== filters.userID)
            if (queryParams.userID !== null && queryParams.userID !== undefined) filters.userID = queryParams.userID; else delete filters.userID;
        return filters;
    }

    updateFilters = () => {
        let filters = { ...this.filtersParams };
        if (this.props.absenceID !== filters.absenceID)
            if (this.props.absenceID !== null && this.props.absenceID !== undefined) filters.absenceID = this.props.absenceID; else delete filters.absenceID
        if (this.props.startDate !== filters.startDate)
            if (this.props.startDate !== null && this.props.startDate !== undefined) filters.startDate = this.props.startDate; else delete filters.startDate
        if (this.props.endDate !== filters.endDate)
            if (this.props.endDate !== null && this.props.endDate !== undefined) filters.endDate = this.props.endDate; else delete filters.endDate
        if (this.state.ouID.value !== filters.ouID)
            if (this.state.ouID.value !== null && this.state.ouID.value !== undefined) filters.ouID = this.state.ouID.value; else delete filters.ouID
        if (this.state.userID.value !== filters.userID)
            if (this.state.userID.value !== null && this.state.userID.value !== undefined) filters.userID = this.state.userID.value; else delete filters.userID
        if (JSON.stringify(this.filtersParams) !== JSON.stringify(filters)) {
            this.filtersParams = filters;
            filters = { page: this.startPage, ...filters };
            history.push({ search: queryString.stringify(filters) });
        }
    };

    toggleFilters = () => this.setState({ filters: !this.state.filters });

    goToRequest = () => {
        if (this.state.requestID && Number.isInteger(this.state.requestID) && this.state.requestID > 0) history.push(`/requests/details/${this.state.requestID}`);
    }

    linkTo = destination => history.push(destination);

    shortTime = time => time.substring(0, time.lastIndexOf(":"));
    monthName = month => ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"][month - 1];

    renderOuFilters = (prefix, units) => {
        let options = []
        units.forEach(unit => {
            options.push({ label: `${prefix} ${unit.symbol} | ${unit.name}`, value: unit.ouID });
            options = [
                ...options,
                ...this.renderOuFilters(`${prefix}_`, unit.subOUs)
            ]
        })
        return options
    };
    
    renderFilters = () => {
        return (
            <div className="ui grid">
                <div className={`${this.props.listType !== "my" ? "five" : "three"} columns row`}>
                    <div className="column">
                        Przyczyna absencji:
                        <Field type="select" name="absenceID" component="select" placeholder="Wybierz przyczynę...">
                            {this.renderOptions()}
                        </Field>
                    </div>
                    <div className="column">
                        Od:
                        <Field type="date" name="startDate" component="input" placeholder="Data początkowa..." />
                    </div>
                    <div className="column">
                        Do:
                        <Field type="date" name="endDate" component="input" placeholder="Data końcowa..." />
                    </div>
                    {this.props.listType !== "my" ? (
                        <React.Fragment>
                            <div className="column">
                                Jednostka organizacyjna:
                                <Select
                                    value={this.state.ouID}
                                    onChange={value => this.setState({ ouID: value })}
                                    options={[{ label: "< Wszystkie >", value: null }, ...this.renderOuFilters("", this.props.unitsList)]}
                                    placeholder="Jednostka organizacyjna"
                                    noOptionsMessage={() => "Nie znaleziono jednostki organizacyjnej"}
                                    maxMenuHeight="400px"
                                />
                            </div>
                            <div className="column">
                                Użytkownik:
                                <Select
                                    value={this.state.userID}
                                    onChange={value => this.setState({ userID: value })}
                                    options={[{ label: "< Wszyscy >", value: null }, ...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u.userID } })]}
                                    placeholder="Użytkownik"
                                    noOptionsMessage={() => "Nie znaleziono użytkownika"}
                                    maxMenuHeight="400px"
                                />
                            </div>
                        </React.Fragment>
                    ) : null}
                </div>
            </div>
        );
    };

    renderOptions = () => {
        return (
            <React.Fragment>
                <option />
                {this.props.reasonsList.map(absence => absence.active <= 1 ? <option key={absence.absenceID} value={absence.absenceID}>{absence.name}</option> : null)}
            </React.Fragment>
        );
    };

    renderRequests = () => this.props.requestList.map(request => {
        return (
            <div className="ui segment-wrapper" key={request.requestID}>
                <div className="ui segment" onClick={() => this.linkTo(`/requests/details/${request.requestID}`)}>
                    {this.renderRequest(request)}
                </div>
            </div>
        );
    });

    renderRequest = request => {
        return (
            <div className="ui grid">
                <div className={`${this.props.listType !== "my" ? "two columns " : ""}row`}>
                    <div className="column">
                        <div className="ui header">Wniosek nr: {request.requestID}<br />o: {request.absenceName}</div>
                        {request.absenceID === 8 ? (
                                <div className="content"><b>Powód:</b> {request.occasionName}</div>
                        ) : null}
                    </div>
                    {this.props.listType !== "my" ? (
                        <div className="right aligned column">
                            <div className="content">Użytkownika <b>{`${request.lname} ${request.fname}`}</b><br />{request.email}<br /><b>{request.ouName}</b></div>
                        </div>
                    ) : null}
                </div>
                <div className="ui divider" />
                <div className="three columns row">
                    <div className="column">
                        <div className="content">
                            {request.absenceID === -1 ? (
                                <React.Fragment>
                                    W dniu: <b>{request.dateFrom}</b>
                                </React.Fragment>
                            ) : "W dniach:"}<br />
                            Od: <b>{request.absenceID === -1 ? this.shortTime(request.timeFrom) : request.dateFrom}</b>
                        </div>
                    </div>
                    <div className="column">
                        <div className="content"><br />do: <b>{request.absenceID === -1 ? this.shortTime(request.timeTo) : request.dateTo}</b></div>
                    </div>
                    <div className="column">
                        <div className="content"><br />{request.absenceID === -1 ? (
                            <React.Fragment>
                                za miesiąc: <b>{this.monthName(request.forMonth)}</b>
                            </React.Fragment>
                        ) : null}</div>
                    </div>
                </div>
                <div className="ui divider" />
                <div className="two columns row">
                    <div className="column">
                        <div className="content">Złożony dnia: <b>{request.submitedOn}</b></div>
                    </div>
                    <div className="right aligned column">
                        {this.renderStatus(request)}
                    </div>
                </div>
            </div>
        );
    };

    renderStatus = request => {
        if (request.canceled === 1) return (<div className="red content"><b>Wycofany</b></div>);
        else if (request.entered === -1) return (<div className="red content"><b>Odrzucony przez kadry</b></div>);
        else if (request.entered === 1) return (<div className="green content"><b>Wpisany w systemie</b></div>);
        else if (request.accepted === 1) return (<div className="green content"><b>Zaakceptowany przez przełożonych</b></div>);
        else if (request.accepted === -1) return (<div className="red content"><b>Odrzucony</b></div>);
        else return (<div className="orange content"><b>Oczekuje na akceptację przełożonych</b></div>);
    };

    renderPagination = () => {
        let buttons = [];
        let ellipsis = true;

        buttons.push(this.renderPaginationButton(-2));
        for (let i = 1; i <= this.props.pages; i++) {
            if ((i < this.page && i - 1 > 0 && this.page - i > (this.page === this.props.pages ? 2 : 1) && this.page - 1 > (this.page === this.props.pages ? 4 : 3)) || (i > this.page && this.props.pages - i > 0 && i - this.page > (this.page === 1 ? 2 : 1) && this.props.pages - this.page > (this.page === 1 ? 4 : 3))) {
                if (ellipsis) {
                    buttons.push(this.renderPaginationButton(i, true));
                    ellipsis = false;
                }
                continue;
            }
            if (i === this.page) ellipsis = true;
            buttons.push(this.renderPaginationButton(i));
        }
        buttons.push(this.renderPaginationButton(-1));

        return (
            <div className="ui pagination menu">
                {buttons}
            </div>
        );
    }

    renderPaginationButton = (page, ellipsis = false) => {
        let destination = page > 0 ? page : (page === -2 ? +this.page - 1 : +this.page + 1);
        return (
            <React.Fragment key={page}>
                {(destination < 1 || destination > this.props.pages || ellipsis) ? (
                    <div className="disabled item">{ellipsis ? "..." : (page > 0 ? page : (page === -2 ? "<" : ">"))}</div>
                ) : (
                    <Link to={`${history.location.pathname}?${queryString.stringify({ page: destination, ...this.filtersParams })}`} className={`${(destination < 1 || destination > this.props.pages) ? "disabled " : ""}item${page === this.page ? " active" : ""}`}>
                        <div className="content">{page > 0 ? page : (page === -2 ? "<" : ">")}</div>
                    </Link>
                )}
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                <div className="request-list-component ui container">
                    <div className={`ui ${(this.props.currentUser.isSupervisor || this.props.currentUser.admin === 1) && this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : 
                    !this.props.currentUser.isSupervisor && this.props.currentUser.ouID !== +process.env.REACT_APP_HR_OU_ID && this.props.currentUser.admin !== 1 ? "two" : "three"} item menu`}>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <Link to="/requests/hr/pending" className={`${(this.props.listType !== "my" && this.props.listScope === "hr") ? "active " : ""}item`}>
                                <div className="content">Wnioski do kadr</div>
                            </Link>
                        ) : null}
                        {this.props.currentUser.isSupervisor || this.props.currentUser.admin === 1 ? (
                            <Link to={`/requests/${this.props.currentUser.isSupervisor ? "pending" : "all"}`} className={`${(this.props.listType !== "my" && this.props.listScope === "supervisor") ? "active " : ""}item`}>
                                <div className="content">Wnioski pracowników</div>
                            </Link>
                        ) : null}
                        <Link to="/requests/my" className={`${this.props.listType === "my" ? "active " : ""}item`}>
                            <div className="content">Moje wnioski</div>
                        </Link>
                        <Link to="/requests/new" className="item">
                            <div className="content">Nowy wniosek</div>
                        </Link>
                    </div>
                    {this.props.listType !== "my" && (this.props.currentUser.isSupervisor || this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID) ? (
                        <div className="ui three item menu">
                            <Link to={`/requests${this.props.listScope === "hr" ? "/hr" : ""}/pending`} className={`${this.props.listType === "pending" ? "active " : ""}item`}>
                                <div className="content">Oczekujące</div>
                            </Link>
                            <Link to={`/requests${this.props.listScope === "hr" ? "/hr" : ""}/other`} className={`${this.props.listType === "other" ? "active " : ""}item`}>
                                <div className="content">Rozpatrzone</div>
                            </Link>
                            <Link to={`/requests${this.props.listScope === "hr" ? "/hr" : ""}/all`} className={`${this.props.listType === "all" ? "active " : ""}item`}>
                                <div className="content">Wszystkie</div>
                            </Link>
                        </div>
                    ) : null}
                    {this.state.filters ? (
                        <React.Fragment>
                            <div className="ui horizontal divider">Filtry</div>
                            <FiltersForm onSubmit={() => {}} renderFields={this.renderFilters} />
                        </React.Fragment>
                    ) : null}
                    <div className="ui toggle container">
                        <button className="ui primary filters button" type="button" onClick={this.toggleFilters}>{this.state.filters ? "Ukryj filtry" : "Filtruj"}</button>
                        <div className="ui action filters input">
                            <input type="number" placeholder="Numer wniosku..." min="1"
                                value={this.state.requestID} onChange={event => this.setState({ requestID: +event.target.value })} />
                            <button className="ui primary button" onClick={this.goToRequest}>Przejdź do wniosku</button>
                        </div>
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.props.requestList.length ? (
                            <React.Fragment>
                                {this.renderRequests()}
                                <div className="ui divider" />
                                {this.renderPagination()}
                            </React.Fragment>
                        ) : (
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className={`${this.props.listType !== "my" ? "clipboard list" : "file alternate"} icon`}></i>
                                        <div className="content">Nie odnaleziono wniosków</div>
                                    </h2>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    reasonsList: state.absence.reasons,
    requestList: state.request.list,
    usersList: state.user.list,
    unitsList: state.structure.list,
    pages: state.request.pages,
    absenceID: formValueSelector("filtersForm")(state, "absenceID"),
    startDate: formValueSelector("filtersForm")(state, "startDate"),
    endDate: formValueSelector("filtersForm")(state, "endDate")
});

export default connect(mapStateToProps, { reset, getSubordinateUnits, getSubordinateUsers, getReasons, getMyRequests, getPendingRequests, getOtherRequests, getAllRequests })(RequestList);